<template>
  <svg
    @click="$emit('click')"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5944 2.36356L7.95845 5.99986L11.5944 9.63599C12.1352 10.177 12.1352 11.0534 11.5944 11.5944C11.3242 11.8647 10.9699 11.9999 10.6158 11.9999C10.2611 11.9999 9.90676 11.8649 9.63674 11.5944L6.00002 7.95791L2.36357 11.5944C2.09338 11.8646 1.73907 11.9999 1.38465 11.9999C1.03033 11.9999 0.676257 11.8648 0.405827 11.5944C-0.135 11.0536 -0.135 10.1772 0.405827 9.63595L4.04165 5.99983L0.40562 2.36356C-0.135207 1.82274 -0.135207 0.946134 0.40562 0.405309C0.946343 -0.135103 1.82243 -0.135103 2.36336 0.405309L5.99998 4.04161L9.63633 0.405309C10.1774 -0.135103 11.0536 -0.135103 11.5942 0.405309C12.1352 0.946134 12.1352 1.82274 11.5944 2.36356Z"
      fill="#98A0A9"
    />
  </svg>
</template>

<script>
export default {
    emits: ['click'],
};
</script>

<style lang="scss" scoped>
svg {
  cursor: pointer;
}
a {
  line-height: 0;
}
</style>
